import { combineReducers } from "redux";
import { reduxDimensions as dimensions } from "reducers/reduxDimensions";
import { reduxXSSearch as XSSearch } from "reducers/reduxXSSearch";
import { sagaExhibitions as exhibitions } from "reducers/sagaExhibitions";
import { sagaNows as nows } from "reducers/sagaNows";
import { sagaNowContents as nowContents } from "reducers/sagaNowContents";

export default combineReducers({
   dimensions,
   exhibitions,
   nows,
   nowContents,
   XSSearch,
});
